// 引入国际化插件
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import localeZH from 'element-ui/lib/locale/lang/zh-CN'
import localeEN from 'element-ui/lib/locale/lang/en'

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: '', // 设置语言环境，
  messages: {
    'zh-cn': require('./zh-cn.js'),
    'en': require('./en.js')
  } // 设置语言环境信息
})

const loadedLanguages = [] // 当前有的语言
function setI18nLanguage (lang) {
  i18n.locale = lang
  locale.use(lang === 'zh-cn' ? localeZH : localeEN)
  return lang
}

export function loadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(`@/lang/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default.langData)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      }).catch((e) => {
        return new Error(e)
      })
    }
  return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}



// WEBPACK FOOTER //
// ./src/lang/i18n-setup.js